import { createContext } from "react";

interface initialStateType {
  state: stateType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setState: any;
}

const authContext = createContext<initialStateType[]>([]);

export default authContext;
